import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Cookies from 'js-cookie';

import Skeleton from '@material-ui/lab/Skeleton';


import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';

import api from '../../../../../services/api';
import NavegadorGestao from "../../../../../components/NavBarGestao";


import { Button } from "@material-ui/core";
import { styled } from '@material-ui/styles';




export default function CondicoesPagamento() {

    const [loading, setLoading] = useState(true);

    const [objetos, setObjetos] = useState(null);

    async function listar() {

        setLoading(true);

        try {
            const token = Cookies.get('token');

            const headers = {
                'Authorization': 'Bearer ' + token
            }


            await api.get("v1/protected/financeiro/condicoespagamento/listartodos", {
                headers: headers
            }).then(function (response) {
                setObjetos(response.data)

                console.log(" Objetos: " + response);
                setLoading(false);


            });


        } catch (_err) {

            console.log("Erro ao listar objetos: " + _err)
            setLoading(false);

        }

    }


    useEffect(() => {



        listar();


    }, []);




    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarFilterButton />
                <GridToolbarDensitySelector />
                <GridToolbarExport />
            </GridToolbarContainer>
        );
    }



    const handleCellClick = (param, event) => {
        event.stopPropagation();
    };

    const handleRowClick = (param, event) => {
        event.stopPropagation();
    };




    const columnsDataGrid = [
        {
            field: 'acoes',
            headerName: 'Ações',
            headerClassName: 'cabecalho_marrom_claro',
            sortable: false,
            width: 100,

        },
        {
            headerName: 'ID',
            field: 'id_condicao_pagamento',
            id: 1,
            width: 50,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Nome',
            field: 'nome',
            id: 2,
            width: 300,
            headerClassName: 'cabecalho_azul',
        },
        {
            headerName: 'Descrição',
            field: 'descricao',
            id: 3,
            width: 300,
            headerClassName: 'cabecalho_azul',
        },
          
        {
    headerName: 'Tipo Intervalo',
    field: 'tipo_intervalo',
    id: 6,
    width: 150,
    headerClassName: 'cabecalho_azul',
renderCell: (params) => {

                let text = '';
                if (params.row.tipo_intervalo === 0)
                    text = "FIXO";
                else if (params.row.tipo_intervalo === 1)
                    text = "Variável";
                
                return (
                    <span>{text}</span>
                )
            },
        },

{
    headerName: 'Intervalo Parcelas',
    field: 'intervalo_parcelas',
    id: 7,
    width: 150,
    headerClassName: 'cabecalho_azul',
},
{
    headerName: 'Intervalo Variável',
    field: 'intervalo_variavel',
    id: 8,
    width: 200,
    headerClassName: 'cabecalho_azul',
},
{
    headerName: '1ª Parcela',
    field: 'intervalo_primeira_parcela',
    id: 9,
    width: 180,
    headerClassName: 'cabecalho_azul',
    
},
{
    headerName: 'Tipo Divisão',
    field: 'tipo_divisao',
    id: 10,
    width: 150,
    headerClassName: 'cabecalho_azul',
     renderCell: (params) => {

                let text = '';
                if (params.row.tipo_divisao === 0)
                    text = "FIXO";
                else if (params.row.tipo_divisao === 1)
                    text = "Variável";
                
                return (
                    <span>{text}</span>
                )
            },
},
{
    headerName: 'Divisão Variável',
    field: 'divisao_variavel',
    id: 11,
    width: 200,
    headerClassName: 'cabecalho_azul',
},
{
    headerName: 'Modalidade',
    field: 'modalidade_condicao',
    id: 12,
    width: 250,
    headerClassName: 'cabecalho_azul',
    
     renderCell: (params) => {

                let text = '';
                if (params.row.modalidade_condicao === 0)
                    text = "À vista antecipado";
                else if (params.row.tipo_divisao === 1)
                    text = "Pós-recebimento da NF";
                
                return (
                    <span>{text}</span>
                )
            },
},

    ];



    function novo() {
        window.location.href = "/gestao/financas/condicoespagamento/cadastrar"

    }



    return (
                      <div >
      
                <Grid
                    container
                    direction="row"
                    justifyContent="flex-end"
                    alignItems="center"
                    item xs={12}
                >
                    <Button style={{ margin: 5 }}
                        variant="contained"
                        color="primary"
                        onClick={novo}
                    >
                        Nova Condição de Pagamento
                    </Button>
                </Grid>
                {loading ?
                    <Skeleton animation={"wave"} width={'100%'} style={{ backgroundColor: '#48D1CC' }}>
                    </Skeleton>
                    :

                    <div>
                        <div style={{ backgroundColor: 'white' }}>
                            {objetos !== null && (
                                <>
                                    <DataGrid
                                        pagination
                                        checkboxSelection
                                        rows={objetos}
                                        getRowId={(row) => row.id_condicao_pagamento}
                                        columns={columnsDataGrid}
                                        disableColumnResize={false}
                                        onCellClick={handleCellClick}
                                        onRowClick={handleRowClick}
                                        components={{
                                            Toolbar: CustomToolbar,
                                        }}
                                    />



                                </>
                            )}
                        </div>
                    </div>
                }


            </div>

 
    );
}



